<template>
  <transition name="comment-modal-fade">
    <div v-if="modelValue" class="comment-modal-mask" @click.self="close">
      <div class="comment-modal-panel">
        <!-- 顶部导航栏 -->
        <div class="comment-modal-header">
          <div class="comment-modal-title">{{ t("commentModal.title") }}</div>
          <button class="close-btn" @click="close">×</button>
        </div>

        <!-- 输入区域 -->
        <div class="input-area">
          <RichEditor
            v-model="content"
            :placeholder="t('commentModal.replyTo', { username: replyTo })"
            :isPost="false"
          />
        </div>

        <!-- 底部工具栏 -->
        <PostToolbar :showSubmit="true" @submit="handleSubmit" />
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits } from "vue";
import { useI18n } from "vue-i18n";
import PostToolbar from "../PostToolbar.vue";
import RichEditor from "../common/RichEditor.vue";
import { useRouter } from "vue-router";
import { useToastStore } from "../../stores";
import { useUserStore } from "@/stores/user";
import { extractRichContent } from "../../utils/richEditor";
const { t } = useI18n();
const router = useRouter();
const toast = useToastStore();
const userStore = useUserStore();
const props = defineProps<{
  modelValue: boolean;
  replyTo?: string;
}>();

const emit = defineEmits(["update:modelValue", "submit"]);
const close = () => emit("update:modelValue", false);

const content = ref("");

const handleSubmit = () => {
  if (!userStore.checkBind()) {
    return;
  }
  // 如果官方账号，则直接发布
  if (userStore.isOfficialAccount) {
    emit("submit", content.value);
    return;
  }

  // 提取并过滤内容
  const extractedContent = extractRichContent(content.value);
  // 检查纯文本长度（去除HTML标签）
  const plainText = extractedContent.content.replace(/<[^>]*>/g, "").trim();
  if (plainText.length < 5) {
    toast.showToast(t("postDetail.commentTooShort"), "error", 2000);
    return;
  }
  // 提交过滤后的安全内容
  emit("submit", extractedContent.content);
};
</script>

<style scoped lang="scss">
.comment-modal-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.comment-modal-panel {
  width: 100vw;
  height: 80vh;
  background: #fff;
  border-radius: 16px 16px 0 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.08);
  animation: slideUp 0.25s;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.comment-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.comment-modal-title {
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  font-size: 24px;
  color: #999;
  background: none;
  border: none;
  cursor: pointer;
}

.comment-list {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.comment-item {
  margin-bottom: 16px;
  .comment-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    .avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      margin-right: 10px;
      object-fit: cover;
      cursor: pointer;
    }
    .user-info {
      display: flex;
      flex-direction: column;
      .username {
        font-weight: 600;
        font-size: 14px;
      }
      .comment-time {
        color: #aaa;
        font-size: 12px;
        margin-top: 2px;
      }
    }
  }
  .comment-content {
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    margin-left: 46px;
  }
}

.input-area {
  padding: 16px 16px 50px;
  height: 100%;
  border-top: 1px solid #f0f0f0;
}

.content-input {
  width: 100%;
  height: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #eee;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  background: #f7f7f7;
  overflow-y: auto;
  outline: none;
}

.content-input:empty:before {
  content: attr(placeholder);
  color: #999;
}

.comment-modal-fade-enter-active,
.comment-modal-fade-leave-active {
  transition: opacity 0.2s;
}

.comment-modal-fade-enter-from,
.comment-modal-fade-leave-to {
  opacity: 0;
}
</style>
